import React from "react";
import { Link } from "react-router-dom";
import "../styles/components/not-found-page.scss";

const NotFoundPage = () => (
  <div className="error-container">
    <h1 className="error-code">404</h1>
    <h2 className="error-message">Page Not Found!</h2>
    <Link className="button-go-home" to="/">
      Go Home Page
    </Link>
  </div>
);

export default NotFoundPage;
